import CardActions from "@material-ui/core/CardActions";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = {
    root: {
        "& > div": {
            margin: 0,
        },
        "& a": {
            borderRadius: 0,
            margin: 0,
        },
        "& button": {
            borderRadius: 0,
            margin: 0,
        },
        padding: 0,
    },
};

export const VariantCardActions = withStyles(styles)(CardActions);
